<template>
  <div>
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>1.营业执照</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart">
            <div class="mr13 beforeStar w150 tr">营业执照：</div>

            <div class="fStart">
              <div class="w128 h130 bgF0F7FF fcenter fDColumn fJCenter cp upload_img creditDto_businessFaceIdOss" v-if="!agreementData.baixinData.creditDto.businessFaceIdOss">
                <img class="w56" src="~@/assets/img/account/word_jpp@2x.png" alt="">
                <div class="mt7 f12">营业执照</div>
                <div class="f12 bCBCBCB plr10 ptb2 mt5 br4">点击此处上传</div>
              </div>
              <input type="file" class="input_upload_other_file" data-filetype="doc,pdf,png,jpg" name="baixinData.creditDto.businessFaceIdOss" data-clearname="baixinData.creditDto.businessFaceId" @change="uploadOSSFile($event, 'agreementData.baixinData.creditDto.businessFaceIdOss')" hidden />
              <div class="w128 h130 bF4F4F4 fcenter fJCenter tc img_style_82 pr" v-if="agreementData.baixinData.creditDto.businessFaceIdOss" :style="{background: 'url(' + getFileUrlByType(agreementData.baixinData.creditDto.businessFaceIdOss) + ') no-repeat center center'}">
                <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.businessFaceIdOssLoading">
                  <div class="w50b f14 cp bgcolor l130 down_file" @click="fileHandleShow(getFileUrl(agreementData.baixinData.creditDto.businessFaceIdOss))">{{fileHandle(agreementData.baixinData.creditDto.businessFaceIdOss)=='show'?'预览':'下载'}}</div>
                  <div class="w50b f14 cp bgcolor l130 reupload_file">重新上传</div>
                </div>
                <Spin class="wh100b ivu_wh100" fix v-else>
                  <div class="wh100b dCC br4 bg00084">
                    <Icon type="ios-time" class="dp-c-waite f22" />
                    <div class="fb mt5 f14 cfff">上传中</div>
                  </div>
                </Spin>
              </div>
            </div>

          </div>
        </div>

        <div class="c999 ml150 mt13">将原件复印后加盖鲜章，上传扫描件。</div>

        <div class="fStart mt22">
          <div class="fStart w33b" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">企业名称：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_custName" placeholder="企业名称" v-model.lazy="agreementData.baixinData.creditDto.custName" data-link="baixinData.creditDto.custName">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">社会统一信用代码：</div>
            <input type="text" disabled class="c999 bgcfcfcf bccc w144 h23 f12 br4 pl7 creditDto_certNo" placeholder="请输入社会统一信用代码" v-model.lazy="agreementData.baixinData.creditDto.certNo" maxlength="18" data-link="baixinData.creditDto.certNo">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">经营地址：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_businessAddr" placeholder="请输入经营地址" v-model.lazy="agreementData.baixinData.creditDto.businessAddr" data-link="baixinData.creditDto.businessAddr">
          </div>
        </div>

        <div class="fStart mt22">
          <div class="fStart w33b" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">联系人姓名：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_cntctor" placeholder="请填写联系人姓名" v-model.lazy="agreementData.baixinData.creditDto.cntctor" data-link="baixinData.creditDto.cntctor">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">经办人手机号：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_cntctTel" placeholder="请填写经办人手机号" data-link="baixinData.creditDto.cntctTel" maxlength="11" v-model.lazy="agreementData.baixinData.creditDto.cntctTel">
          </div>
        </div>

        <div class="fStart mt22">
          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">上一年度利润表：</div>

            <div class="fStart">
              <div class="w128 h130 bgF0F7FF fcenter fDColumn fJCenter cp upload_img creditDto_preyearProfitStatementIdOss" v-if="!agreementData.baixinData.creditDto.preyearProfitStatementIdOss">
                <img class="w56" src="~@/assets/img/account/word_jpp@2x.png" alt="">
                <div class="mt7 f12">上一年度利润表</div>
                <div class="f12 bCBCBCB plr10 ptb2 mt5 br4">点击此处上传</div>
              </div>
              <input type="file" class="input_upload_other_file" data-filetype="doc,pdf,png,jpg" name="baixinData.creditDto.preyearProfitStatementIdOss" data-clearname="baixinData.creditDto.preyearProfitStatementId" @change="uploadOSSFile($event, 'agreementData.baixinData.creditDto.preyearProfitStatementIdOss')" hidden />
              <div class="w128 h130 bF4F4F4 fcenter fJCenter tc img_style_82 pr" v-if="agreementData.baixinData.creditDto.preyearProfitStatementIdOss" :style="{background: 'url(' + getFileUrlByType(agreementData.baixinData.creditDto.preyearProfitStatementIdOss) + ') no-repeat center center'}">
                <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.preyearProfitStatementIdOssLoading">
                  <div class="w50b f14 cp bgcolor l130 down_file" @click="fileHandleShow(getFileUrl(agreementData.baixinData.creditDto.preyearProfitStatementIdOss))">{{fileHandle(agreementData.baixinData.creditDto.preyearProfitStatementIdOss)=='show'?'预览':'下载'}}</div>
                  <div class="w50b f14 cp bgcolor l130 reupload_file">重新上传</div>
                </div>
                <Spin class="wh100b ivu_wh100" fix v-else>
                  <div class="wh100b dCC br4 bg00084">
                    <Icon type="ios-time" class="dp-c-waite f22" />
                    <div class="fb mt5 f14 cfff">上传中</div>
                  </div>
                </Spin>
              </div>
            </div>

          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">上一年度资产负债表：</div>

            <div class="fStart">
              <div class="w128 h130 bgF0F7FF fcenter fDColumn fJCenter cp upload_img creditDto_preyearBalanceSheetIdOss" v-if="!agreementData.baixinData.creditDto.preyearBalanceSheetIdOss">
                <img class="w56" src="~@/assets/img/account/word_jpp@2x.png" alt="">
                <div class="mt7 f12">上一年度资产负债表</div>
                <div class="f12 bCBCBCB plr10 ptb2 mt5 br4">点击此处上传</div>
              </div>
              <input type="file" class="input_upload_other_file" data-filetype="doc,pdf,png,jpg" name="baixinData.creditDto.preyearBalanceSheetIdOss" data-clearname="baixinData.creditDto.preyearBalanceSheetId" @change="uploadOSSFile($event, 'agreementData.baixinData.creditDto.preyearBalanceSheetIdOss')" hidden />
              <div class="w128 h130 bF4F4F4 fcenter fJCenter tc img_style_82 pr" v-if="agreementData.baixinData.creditDto.preyearBalanceSheetIdOss" :style="{background: 'url(' + getFileUrlByType(agreementData.baixinData.creditDto.preyearBalanceSheetIdOss) + ') no-repeat center center'}">
                <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.preyearBalanceSheetIdOssLoading">
                  <div class="w50b f14 cp bgcolor l130 down_file" @click="fileHandleShow(getFileUrl(agreementData.baixinData.creditDto.preyearBalanceSheetIdOss))">{{fileHandle(agreementData.baixinData.creditDto.preyearBalanceSheetIdOss)=='show'?'预览':'下载'}}</div>
                  <div class="w50b f14 cp bgcolor l130 reupload_file">重新上传</div>
                </div>
                <Spin class="wh100b ivu_wh100" fix v-else>
                  <div class="wh100b dCC br4 bg00084">
                    <Icon type="ios-time" class="dp-c-waite f22" />
                    <div class="fb mt5 f14 cfff">上传中</div>
                  </div>
                </Spin>
              </div>
            </div>

          </div>

          <div class="fStart w33b">
            <div class="mr13 w150 tr">
              <div class="beforeStar mb5">
                贴现业务协议：
              </div>
              <a href="static/img/img_file/中信百信银行电子银行承兑汇票贴现业务协议（2020年第五版）.pdf" download><button class="cp mb10 plr10 downLoad" data-index="9">下载协议模版</button></a>
              <div class="c999">将原件复印后加盖鲜章，上传扫描件。</div>
            </div>

            <div class="fStart">
              <div class="w128 h130 bgF0F7FF fcenter fDColumn fJCenter cp upload_img creditDto_authorizationAgreementOss" v-if="!agreementData.baixinData.creditDto.authorizationAgreementOss">
                <img class="w56" src="~@/assets/img/account/word_jpp@2x.png" alt="">
                <div class="mt7 f12">贴现业务协议</div>
                <div class="f12 bCBCBCB plr10 ptb2 mt5 br4">点击此处上传</div>
              </div>
              <input type="file" class="input_upload_other_file" data-filetype="doc,pdf,png,jpg" name="baixinData.creditDto.authorizationAgreementOss" data-clearname="baixinData.creditDto.authorizationAgreement" @change="uploadOSSFile($event, 'agreementData.baixinData.creditDto.authorizationAgreementOss')" hidden />
              <div class="w128 h130 bF4F4F4 fcenter fJCenter tc img_style_82 pr" v-if="agreementData.baixinData.creditDto.authorizationAgreementOss" :style="{background: 'url(' + getFileUrlByType(agreementData.baixinData.creditDto.authorizationAgreementOss) + ') no-repeat center center'}">
                <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.authorizationAgreementOssLoading">
                  <div class="w50b f14 cp bgcolor l130 down_file" @click="fileHandleShow(getFileUrl(agreementData.baixinData.creditDto.authorizationAgreementOss))">{{fileHandle(agreementData.baixinData.creditDto.authorizationAgreementOss)=='show'?'预览':'下载'}}</div>
                  <div class="w50b f14 cp bgcolor l130 reupload_file">重新上传</div>
                </div>
                <Spin class="wh100b ivu_wh100" fix v-else>
                  <div class="wh100b dCC br4 bg00084">
                    <Icon type="ios-time" class="dp-c-waite f22" />
                    <div class="fb mt5 f14 cfff">上传中</div>
                  </div>
                </Spin>
              </div>
            </div>

          </div>
        </div>

        <div class="fStart mt22">
          <div class="fStart w33b">
            <div class="mr13 w150 tr">
              <div class="beforeStar mb5">
                百信银行征信授权书：
              </div>
              <a href="static/img/img_file/百信银行征信授权书.pdf" download><button class="cp mb10 plr10 downLoad" data-index="9">下载协议模版</button></a>
              <div class="c999">将原件复印后加盖鲜章，上传扫描件。</div>
            </div>

            <div class="fStart">
              <div class="w128 h130 bgF0F7FF fcenter fDColumn fJCenter cp upload_img creditDto_bxBankLetterOfAuthorizationOss" v-if="!agreementData.baixinData.creditDto.bxBankLetterOfAuthorizationOss">
                <img class="w56" src="~@/assets/img/account/word_jpp@2x.png" alt="">
                <div class="mt7 f12">百信银行征信授权书</div>
                <div class="f12 bCBCBCB plr10 ptb2 mt5 br4">点击此处上传</div>
              </div>
              <input type="file" class="input_upload_other_file" data-filetype="doc,pdf,png,jpg" name="baixinData.creditDto.bxBankLetterOfAuthorizationOss" data-clearname="baixinData.creditDto.bxBankLetterOfAuthorization" @change="uploadOSSFile($event, 'agreementData.baixinData.creditDto.bxBankLetterOfAuthorizationOss')" hidden />
              <div class="w128 h130 bF4F4F4 fcenter fJCenter tc img_style_82 pr" v-if="agreementData.baixinData.creditDto.bxBankLetterOfAuthorizationOss" :style="{background: 'url(' + getFileUrlByType(agreementData.baixinData.creditDto.bxBankLetterOfAuthorizationOss) + ') no-repeat center center'}">
                <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.bxBankLetterOfAuthorizationOssLoading">
                  <div class="w50b f14 cp bgcolor l130 down_file" @click="fileHandleShow(getFileUrl(agreementData.baixinData.creditDto.bxBankLetterOfAuthorizationOss))">{{fileHandle(agreementData.baixinData.creditDto.bxBankLetterOfAuthorizationOss)=='show'?'预览':'下载'}}</div>
                  <div class="w50b f14 cp bgcolor l130 reupload_file">重新上传</div>
                </div>
                <Spin class="wh100b ivu_wh100" fix v-else>
                  <div class="wh100b dCC br4 bg00084">
                    <Icon type="ios-time" class="dp-c-waite f22" />
                    <div class="fb mt5 f14 cfff">上传中</div>
                  </div>
                </Spin>
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>

    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>2.法人身份证</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">人像面：</div>
            <div class="w128 h80 bF4F4F4 fcenter fDColumn fJCenter cp upload_img creditDto_identityFaceIdOss" v-if="!agreementData.baixinData.creditDto.identityFaceIdOss">
              <div class="fcenter fJCenter b2pCBCBCB cff8200 f14 br4 w72 h27">+</div>
              <div class="mt7">选择文件</div>
            </div>
            <input type="file" class="input_upload_img" data-uploadtype="oss" name="baixinData.creditDto.identityFaceIdOss" data-clearname="baixinData.creditDto.identityFaceId" @change="getImg($event, 'agreementData.baixinData.creditDto.identityFaceIdOss')" hidden />
            <div class="w128 h80 bF4F4F4 fcenter fJCenter tc img_style pr" v-if="agreementData.baixinData.creditDto.identityFaceIdOss" :style="{background: 'url(' + getUrlOrBase64(agreementData.baixinData.creditDto.identityFaceIdOss) + ') no-repeat center center'}">
              <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.identityFaceIdOssLoading">
                <div class="w50b f12 cp bgcolor l78 show_img" @click="searchImg(getUrlOrBase64(agreementData.baixinData.creditDto.identityFaceIdOss))">预览</div>
                <div class="w50b f12 cp bgcolor l78 reupload_img">重新上传</div>
              </div>
              <Spin class="wh100b ivu_wh100" fix v-else>
                <div class="wh100b dCC br4 bg00084">
                  <Icon type="ios-time" class="dp-c-waite f22" />
                  <div class="fb mt5 f14 cfff">上传中</div>
                </div>
              </Spin>
            </div>
          </div>
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">国徽面：</div>
            <div class="w128 h80 bF4F4F4 fcenter fDColumn fJCenter cp upload_img creditDto_identityBackIdOss" v-if="!agreementData.baixinData.creditDto.identityBackIdOss">
              <div class="fcenter fJCenter b2pCBCBCB cff8200 f14 br4 w72 h27">+</div>
              <div class="mt7">选择文件</div>
            </div>
            <input type="file" class="input_upload_img" data-uploadtype="oss" name="baixinData.creditDto.identityBackIdOss" data-clearname="baixinData.creditDto.identityBackId" @change="getImg($event, 'agreementData.baixinData.creditDto.identityBackIdOss')" hidden />
            <div class="w128 h80 bF4F4F4 fcenter fJCenter tc img_style pr" v-if="agreementData.baixinData.creditDto.identityBackIdOss" :style="{background: 'url(' + getUrlOrBase64(agreementData.baixinData.creditDto.identityBackIdOss) + ') no-repeat center center'}">
              <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.identityBackIdOssLoading">
                <div class="w50b f12 cp bgcolor l78 show_img" @click="searchImg(getUrlOrBase64(agreementData.baixinData.creditDto.identityBackIdOss))">预览</div>
                <div class="w50b f12 cp bgcolor l78 reupload_img">重新上传</div>
              </div>
              <Spin class="wh100b ivu_wh100" fix v-else>
                <div class="wh100b dCC br4 bg00084">
                  <Icon type="ios-time" class="dp-c-waite f22" />
                  <div class="fb mt5 f14 cfff">上传中</div>
                </div>
              </Spin>
            </div>
          </div>
        </div>

        <div class="c999 ml150 mt13">请上传最新证件原件的彩色扫描件或数码照，如使用复印件请加盖公章</div>

        <div class="fStart mt22">
          <div class="fStart w33b" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">法人姓名：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_legalPersonName" placeholder="法人姓名" data-link="baixinData.creditDto.legalPersonName" v-model.lazy="agreementData.baixinData.creditDto.legalPersonName">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">法人身份证号：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_legalIdNum" placeholder="请输入法人身份证号" v-model.lazy="agreementData.baixinData.creditDto.legalIdNum" maxlength="18" data-link="baixinData.creditDto.legalIdNum">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">法人身份证地址：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_legalAddr" placeholder="请输入法人身份证地址" v-model.lazy="agreementData.baixinData.creditDto.legalAddr" data-link="baixinData.creditDto.legalAddr">
          </div>

        </div>

        <div class="fStart mt22">
          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">法人证件登记日期：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDate dateParentNotArray creditDto_idtStartDate1" placeholder="请选择证件登记日期" data-link="baixinData.creditDto.idtStartDate1" v-model.lazy="agreementData.baixinData.creditDto.idtStartDate1">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">法人证件到期日：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDateLong dateParentNotArray creditDto_idtEndDate1" placeholder="请选择证件到期日期" data-link="baixinData.creditDto.idtEndDate1" v-model.lazy="agreementData.baixinData.creditDto.idtEndDate1">
          </div>
        </div>

      </div>
    </div>

    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>3.受益人信息</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">人像面：</div>
            <div class="w128 h80 bF4F4F4 fcenter fDColumn fJCenter cp upload_img creditDto_bnfIdNumDueOss" v-if="!agreementData.baixinData.creditDto.bnfIdNumDueOss">
              <div class="fcenter fJCenter b2pCBCBCB cff8200 f14 br4 w72 h27">+</div>
              <div class="mt7">选择文件</div>
            </div>
            <input type="file" class="input_upload_img" data-uploadtype="oss" name="baixinData.creditDto.bnfIdNumDueOss" data-clearname="baixinData.creditDto.bnfIdNumDue" @change="getImg($event, 'agreementData.baixinData.creditDto.bnfIdNumDueOss')" hidden />
            <div class="w128 h80 bF4F4F4 fcenter fJCenter tc img_style pr" v-if="agreementData.baixinData.creditDto.bnfIdNumDueOss" :style="{background: 'url(' + getUrlOrBase64(agreementData.baixinData.creditDto.bnfIdNumDueOss) + ') no-repeat center center'}">
              <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.bnfIdNumDueOssLoading">
                <div class="w50b f12 cp bgcolor l78 show_img" @click="searchImg(getUrlOrBase64(agreementData.baixinData.creditDto.bnfIdNumDueOss))">预览</div>
                <div class="w50b f12 cp bgcolor l78 reupload_img">重新上传</div>
              </div>
              <Spin class="wh100b ivu_wh100" fix v-else>
                <div class="wh100b dCC br4 bg00084">
                  <Icon type="ios-time" class="dp-c-waite f22" />
                  <div class="fb mt5 f14 cfff">上传中</div>
                </div>
              </Spin>
            </div>
          </div>
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">国徽面：</div>
            <div class="w128 h80 bF4F4F4 fcenter fDColumn fJCenter cp upload_img creditDto_bnfIdNumBackOss" v-if="!agreementData.baixinData.creditDto.bnfIdNumBackOss">
              <div class="fcenter fJCenter b2pCBCBCB cff8200 f14 br4 w72 h27">+</div>
              <div class="mt7">选择文件</div>
            </div>
            <input type="file" class="input_upload_img" data-uploadtype="oss" name="baixinData.creditDto.bnfIdNumBackOss" data-clearname="baixinData.creditDto.bnfIdNumBack" @change="getImg($event, 'agreementData.baixinData.creditDto.bnfIdNumBackOss')" hidden />
            <div class="w128 h80 bF4F4F4 fcenter fJCenter tc img_style pr" v-if="agreementData.baixinData.creditDto.bnfIdNumBackOss" :style="{background: 'url(' + getUrlOrBase64(agreementData.baixinData.creditDto.bnfIdNumBackOss) + ') no-repeat center center'}">
              <div class="img_hover_style" v-if="!agreementData.baixinData.creditDto.bnfIdNumBackOssLoading">
                <div class="w50b f12 cp bgcolor l78 show_img" @click="searchImg(getUrlOrBase64(agreementData.baixinData.creditDto.bnfIdNumBackOss))">预览</div>
                <div class="w50b f12 cp bgcolor l78 reupload_img">重新上传</div>
              </div>
              <Spin class="wh100b ivu_wh100" fix v-else>
                <div class="wh100b dCC br4 bg00084">
                  <Icon type="ios-time" class="dp-c-waite f22" />
                  <div class="fb mt5 f14 cfff">上传中</div>
                </div>
              </Spin>
            </div>
          </div>
        </div>

        <div class="c999 ml150 mt13">请上传最新证件原件的彩色扫描件或数码照，如使用复印件请加盖公章</div>

        <div class="fStart mt22">
          <div class="fStart w33b" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">受益人姓名：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_bnfName" placeholder="受益人姓名" data-link="baixinData.creditDto.bnfName" v-model.lazy="agreementData.baixinData.creditDto.bnfName">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">受益人身份证号：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_bnfCertNo" placeholder="请输入受益人身份证号" v-model.lazy="agreementData.baixinData.creditDto.bnfCertNo" maxlength="18" data-link="baixinData.creditDto.bnfCertNo">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">受益人身份证地址：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 creditDto_bnfAddr" placeholder="请输入受益人身份证地址" v-model.lazy="agreementData.baixinData.creditDto.bnfAddr" data-link="baixinData.creditDto.bnfAddr">
          </div>

        </div>

        <div class="fStart mt22">
          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">受益人证件登记日期：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDate dateParentNotArray creditDto_startDate1" placeholder="请选择证件登记日期" data-link="baixinData.creditDto.startDate1" v-model.lazy="agreementData.baixinData.creditDto.startDate1">
          </div>

          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">受益人证件到期日：</div>
            <input type="text" class="be9e9e9 w144 h23 f12 br4 pl7 maturityDateLong dateParentNotArray creditDto_endDate1" placeholder="请选择证件到期日期" data-link="baixinData.creditDto.endDate1" v-model.lazy="agreementData.baixinData.creditDto.endDate1">
          </div>
        </div>

      </div>
    </div>

    <div class="mt43 fJCenter pb20">
      <Button class="w110 btnff8200bg tc cp br4 submit" type="primary" @click="submit()">确认</Button>
    </div>
  </div>
</template>

<script>
import "@/assets/js/foundation-datepicker.js";
import "@/assets/js/maturityTandem.js";
import { uploadBaixinFile } from '@/api/bankAgreement.js'

let _this = '';

export default {
  name: "agreementMenu",
  components: {},
  data () {
    return {
      agreementData: {
        // 百信协议请求参数--自渠道
        baixinData: {
          discountChannel: 'BAIXIN',
          status: "",
          bankId: '', // 签约银行信息主键id
          // recommenedCode: '', // 业务推荐码
          creditDto: {

            businessFaceIdOss: '', // 营业执照图片
            businessFaceId: '', // 营业执照 取文件上传接口fileUrl返回值
            custName: '', // 公司名称
            certNo: '', // 证件号(固定是统一社会信用代码)
            cntctor: '', // 联系人
            cntctTel: '', // 联系电话
            businessAddr: '', // 经营地址 取文件上传接口billType=01的businessAddr返回值

            preyearProfitStatementId: '', // 上一年度利润表ID 取文件上传接口fileUrl返回值
            preyearProfitStatementIdOss: '', // 上一年度利润表ID Oss
            preyearBalanceSheetId: '', // 上一年度资产负债表ID 取文件上传接口fileUrl返回值
            preyearBalanceSheetIdOss: '', // 上一年度资产负债表ID Oss
            authorizationAgreement: '', // 贴现业务协议 取文件上传接口fileUrl返回值
            authorizationAgreementOss: '', // 贴现业务协议 Oss
            bxBankLetterOfAuthorization: '', // 百信银行征信授权书 取文件上传接口fileUrl返回值
            bxBankLetterOfAuthorizationOss: '', // 百信银行征信授权书 Oss


            identityFaceIdOss: "", // 法定代表人身份证（人像面）Oss
            identityFaceId: '', // 法定代表人身份证（人像面）取文件上传接口fileUrl返回值
            identityBackIdOss: "", // 法定代表人身份证（国徽面）Oss
            identityBackId: '', // 法定代表人身份证（国徽面）取文件上传接口fileUrl返回值
            legalPersonName: '', // 法人名称 取文件上传接口billType=02的cName返回值
            legalIdNum: '', // 法人身份证号 取文件上传接口billType=02的cName返回值
            legalValidDates: '', // 法人身份证有效期 取文件上传接口billType=03的validDates返回值例:19600101-20600101或19600101-长期
            idtStartDate1: '',
            idtEndDate1: '',
            legalAddr: '', // 法人身份证地址 取文件上传接口billType=02的addr返回值

            bnfIdNumDue: '', // 受益人身份证（正） 取文件上传接口fileUrl返回值
            bnfIdNumDueOss: '', // 受益人身份证（正） Oss

            bnfIdNumBack: '', // 受益人身份证（反）取文件上传接口fileUrl返回值
            bnfIdNumBackOss: '', // 受益人身份证（反）Oss
            bnfName: '', // 受益人名称 取文件上传接口billType=14的cName返回值
            bnfCertNo: '', // 受益人证件号码 取文件上传接口billType=14的validDates返回值
            bnfValidDates: '', // 受益人身份证有效期 取文件上传接口billType=15的addr返回值 例:19600101-20600101或19600101-长期
            startDate1: '',
            endDate1: '',
            bnfAddr: '', // 受益人地址 取文件上传接口billType=14的cName返回值

          },
        },

        // 协议类型
        type: "", // "YNHT":红塔协议，"FM":富民协议，"WHLH":蓝海协议
        discountChannel: '',

        // 协议参数名
        paramName: "", //

        // 选择参数列表
        baseDate: {
          // 秒贴对象类型
          corp: {},
          // 企业所有制类型
          orgOwnershipType: [],
          // 国标行业分类(兴业提供的编码)
          industryType: [],
          // 机构类型
          orgType: [],
          // 企业类型
          corpType: [],
          // 证件类型
          certType: [],
          // 地区信息（兴业提供的编码）
          areaCode: [],
          // 出资方式
          investmentForm: [],
          // 职务类型
          positionType: [],
          // 股东类型
          stockholderType: [],
          // 关联企业企业类型
          relatedCorpType: [],
          // 关联企业企业证件类型
          relatedCorpCertType: [],
          // 注册资本币种
          registerCurrency: [],
          // 上市公司类型
          listedCorpType: [],
          // 企业行业类型
          corpIndustyType: [],
        },

        // 当前签约银行的行业分类
        cuIndustry: ''
      },
      // 是否存储当前数据
      saveData: true,
      uploadNum: 0,
      subtype: '' // 二级协议类型
    }
  },
  methods: {
    initData: function (bankId) {
      _this.addLoading();
      // 请求初始化数据参数
      this.sendGet({
        method: 'get',
        url: '/web/discount-acct/bank/credit',
        data: {
          bank_id: bankId,
        },
      }, (result) => {
        // console.log("this.agreementData.baseDate");
        // this.agreementData.baseDate.corp = result.data.data;
        $.extend(true, this.agreementData.baseDate.corp, result.data.data)
        this.agreementData.cuIndustry = result.data.data.creditParam && result.data.data.creditParam.industryType;
        this.agreementData.type = result.data.data.bankCode;
        this.agreementData.discountChannel = result.data.data.discountChannel;

        switch (result.data.data.bankCode) {
          case "BAIXIN": {
            this.agreementData.paramName = "baixinData";
            break;
          }
        }
        // console.log("result.data.data.bankCode", result.data.data.bankCode);
        if (localStorage.getItem("signBank" + bankId)) {
          this.agreementData = JSON.parse(localStorage.getItem("signBank" + bankId));
          // 如果没有当前银行的所属行业分类，则去获取
          if (!this.agreementData.cuIndustry) {
            if (_this.agreementData.type == "ZHENX") { // 振兴协议特别
              this.agreementData.cuIndustry = result.data.data.creditParam.industryTypeZhenx;
            } else if (_this.agreementData.type == "ZBANK") { // 众邦协议特别
              this.agreementData.cuIndustry = result.data.data.creditParam.industryTypeZbank;
            } else { // 京东协议
              this.agreementData.cuIndustry = result.data.data.creditParam && result.data.data.creditParam.industryType;
            }
          }

          // 关联企业 按钮事件
          this.$nextTick(function () {
            // console.log($(".relevanceCompany"), 'relevanceCompany nextTick', this.agreementData.baseDate.corp.bankSubDto.creditDto.acctInfoList);
            if (!(this.agreementData.baseDate.corp.bankSubDto.creditDto.hasOwnProperty('acctInfoList') && this.agreementData.baseDate.corp.bankSubDto.creditDto.acctInfoList != null && this.agreementData.baseDate.corp.bankSubDto.creditDto.acctInfoList.length > 0)) {
              $(".relevanceCompany").click();
            } else {
              this.agreementData[this.agreementData.paramName].creditDto.acctInfoList = this.agreementData.baseDate.corp.bankSubDto.creditDto.acctInfoList;
            }
          })

          // 设置金额不能为大写的字符
          _this.noAmountWords([
            'creditDto.regCapital', // 注册资本
            'creditDto.paiclupCapital', // 实收资本
            'creditDto.totalAssets',  // 资产总额
            'creditDto.annualSale', // 年销售额
            'creditDto.sellSum', // 上一年度销售额
            'creditDto.rgstCptlAmt', // 注册资本--众邦
            'creditDto.collctCptlAmt', // 实收资本--众邦
            'creditDto.lstYearSlsAmt', // 上年年销售额--众邦
            'creditDto.totAssts', // 总资产--众邦
          ]);
          return false;
        }
        let cu = result.data;
        // 若后台返回的是空数组，则按照初始化赋值
        // console.log(cu.data.bankSubDto, "cu.data.bankSubDto");
        for (let i in cu.data.bankSubDto.creditDto) {
          // // console.log(cu.data.bankSubDto.creditDto, "i", i);
          cu.data.bankSubDto.creditDto[i] ? '' : cu.data.bankSubDto.creditDto[i] = '';

          if (i == 'licenceFileList') {
            // // console.log($.extend(this.agreementData[this.agreementData.paramName].creditDto[i], cu.data.bankSubDto.creditDto[i]), 'deep');
            // cu.data.creditParam[i] = $.extend(this.agreementData[this.agreementData.paramName].creditDto[i], cu.data.bankSubDto.creditDto[i]);

            for (var j in this.agreementData[this.agreementData.paramName].creditDto[i]) {
              for (var k in cu.data.bankSubDto.creditDto[i]) {
                if (this.agreementData[this.agreementData.paramName].creditDto[i][j].matTyp == cu.data.bankSubDto.creditDto[i][k].matTyp) {
                  this.agreementData[this.agreementData.paramName].creditDto[i][j].filePic = cu.data.bankSubDto.creditDto[i][k].filePic;
                  this.agreementData[this.agreementData.paramName].creditDto[i][j].fileId = cu.data.bankSubDto.creditDto[i][k].fileId;
                }
              }
            }
            cu.data.bankSubDto.creditDto[i] = this.agreementData[this.agreementData.paramName].creditDto[i];
            // console.log(this.agreementData[this.agreementData.paramName].creditDto[i]);
            continue;
          } else if (i == 'fileDataList') {
            // // console.log($.extend(this.agreementData[this.agreementData.paramName].creditDto[i], cu.data.bankSubDto.creditDto[i]), 'deep');
            // cu.data.creditParam[i] = $.extend(this.agreementData[this.agreementData.paramName].creditDto[i], cu.data.bankSubDto.creditDto[i]);

            for (var j in this.agreementData[this.agreementData.paramName].creditDto[i]) {
              for (var k in cu.data.bankSubDto.creditDto[i]) {
                if (this.agreementData[this.agreementData.paramName].creditDto[i][j].flTp == cu.data.bankSubDto.creditDto[i][k].flTp) {
                  this.agreementData[this.agreementData.paramName].creditDto[i][j].filePic = cu.data.bankSubDto.creditDto[i][k].filePic;
                  this.agreementData[this.agreementData.paramName].creditDto[i][j].flPth = cu.data.bankSubDto.creditDto[i][k].flPth;
                }
              }
            }
            cu.data.bankSubDto.creditDto[i] = this.agreementData[this.agreementData.paramName].creditDto[i];
            // console.log(this.agreementData[this.agreementData.paramName].creditDto[i]);
            continue;
          }

          if ($.isArray(cu.data.bankSubDto.creditDto[i])) {
            if ((cu.data.bankSubDto.creditDto[i].length == 0)) {
              cu.data.bankSubDto.creditDto[i] = this.agreementData[this.agreementData.paramName].creditDto[i];
            }
          } else {
            // 如果初始化的签约要素是数组时则赋值
            if ($.isArray(this.agreementData[this.agreementData.paramName].creditDto[i])) {
              cu.data.bankSubDto.creditDto[i] = this.agreementData[this.agreementData.paramName].creditDto[i];
            }
          }
        }

        // 处理”推荐码“
        if (cu.data.bankSubDto.recommenedCode != "") {
          this.agreementData[this.agreementData.paramName].recommenedCode = cu.data.bankSubDto.recommenedCode;
        }

        $.extend(true, this.agreementData[this.agreementData.paramName], cu.data.bankSubDto);
        $.extend(true, this.agreementData.baseDate, cu.data.creditParam);
        this.agreementData.status = cu.data.status;

        // console.log(this.agreementData);

        // 关联企业 按钮事件
        this.$nextTick(function () {
          // console.log($(".relevanceCompany"), 'relevanceCompany nextTick', this.agreementData.baseDate.corp.bankSubDto.creditDto.acctInfoList);
          if (!(this.agreementData.baseDate.corp.bankSubDto.creditDto.hasOwnProperty('acctInfoList') && this.agreementData.baseDate.corp.bankSubDto.creditDto.acctInfoList != null && this.agreementData.baseDate.corp.bankSubDto.creditDto.acctInfoList.length > 0)) {
            $(".relevanceCompany").click();
          }
        })

        if (this.agreementData[this.agreementData.paramName].creditDto.legalValidDates) {
          this.agreementData[this.agreementData.paramName].creditDto.idtStartDate1 = this.agreementData[this.agreementData.paramName].creditDto.legalValidDates.split('-')[0].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');
          this.agreementData[this.agreementData.paramName].creditDto.idtEndDate1 = this.agreementData[this.agreementData.paramName].creditDto.legalValidDates.split('-')[1].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');
        }
        if (this.agreementData[this.agreementData.paramName].creditDto.bnfValidDates) {
          this.agreementData[this.agreementData.paramName].creditDto.startDate1 = this.agreementData[this.agreementData.paramName].creditDto.bnfValidDates.split('-')[0].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');
          this.agreementData[this.agreementData.paramName].creditDto.endDate1 = this.agreementData[this.agreementData.paramName].creditDto.bnfValidDates.split('-')[1].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');
        }

        _this.noAmountWords([
          'creditDto.regCapital', // 注册资本
          'creditDto.paiclupCapital', // 实收资本
          'creditDto.totalAssets',  // 资产总额
          'creditDto.annualSale', // 年销售额
          'creditDto.sellSum', // 上一年度销售额
          'creditDto.rgstCptlAmt', // 注册资本--众邦
          'creditDto.collctCptlAmt', // 实收资本--众邦
          'creditDto.lstYearSlsAmt', // 上年年销售额--众邦
          'creditDto.totAssts', // 总资产--众邦
        ]);

        console.log(this.agreementData[this.agreementData.paramName])
        _this.removeLoading();

      }, result => {
        // 失败
      })
    },
    // 提交数据
    submit () {
      console.log(this.agreementData[this.agreementData.paramName]);
      let none_ststus = false; // 判断是否存在没有填写的数据

      checkDate(this.agreementData[this.agreementData.paramName]);

      if (none_ststus) {
        _this.$Message.warning("请先完善页面相关信息");
        return false;
      }

      if ($("input[type=checkbox][name=agreementCheckbox]").length > 0) {
        if (!$("input[type=checkbox][name=agreementCheckbox]")[0].checked) {
          this.$Message.warning("请先同意相关协议");
          return false;
        }
      }

      // 判断是否存在没有填写的数据
      function checkDate (data) {
        var twoStatus = {};
        // 一级
        for (var i in data) {
          if (data[i] == "" || data[i] == undefined || data[i] == null) { // 一级没有值的情况下
            if (i != "recommenedCode") { // 判断是否是推荐码
              if ($('.' + i).length > 0) { // 判断页面是否有这个元素
                $('.' + i).addClass('red');
                none_ststus = true;
                // // console.log($('.' + i), 'red', i);
                console.log("一级没有值", i, data[i]);
              }
            }
          } else if (data[i] instanceof Object) { // 一级是对象的情况
            // console.log("一级是对象的情况", i, data[i]);
            if (i.indexOf("jQuery") < 0) {
              // 二级
              for (var j in data[i]) {
                if (data[i][j] == "" || data[i][j] == undefined || data[i][j] == null) { // 二级没有值的情况
                  if ($('.' + i + '_' + j).length > 0) {
                    $('.' + i + '_' + j).addClass('red');
                    none_ststus = true;
                    // // console.log($('.' + i + '_' + j), 'red', i, j);
                    console.log("二级没有值的情况", i, j, data[i][j]);
                  }

                  // // console.log('.' + i + '_' + j, $('.' + i + '_' + j))
                } else if (data[i][j] instanceof Object) { // 二级是对象的情况或者是数组的情况
                  // console.log("二级是对象的情况或者是数组的情况", i, j, data[i][j]);
                  if (i.indexOf("jQuery") < 0) { // 将值为jquery舍去
                    twoStatus[j] = false; // 默认有值，不需要添加红色边框

                    // 三级
                    for (var k in data[i][j]) {
                      if (data[i][j][k] instanceof Object) { // 三级是对象的情况或者是数组的情况
                        // console.log("三级是对象的情况或者是数组的情况", i, j, k, data[i][j][k]);
                        if (i.indexOf("jQuery") < 0) { // 将值为jquery舍去


                          // 四级
                          for (var m in data[i][j][k]) {
                            if (data[i][j][k][m] == "" || data[i][j][k][m] == undefined || data[i][j][k][m] == null) { // 四级没有值的情况
                              console.log("四级没有值的情况", i, j, k, m, data[i][j][k][m]);
                              if (_this.agreementData.paramName == "zhongbangData" || _this.agreementData.paramName == "zhenxingData") { // 兴业协议的判断
                                if ($('.' + i + '_' + j + '_' + k + '_' + m).length > 0) {
                                  $('.' + i + '_' + j + '_' + k + '_' + m).addClass('red');
                                  none_ststus = true;
                                  // // console.log($('.' + i + '_' + j + '_' + k + '_' + m), 'red', i,j,k,m);
                                }
                              } else { // 京东协议的判断
                                if (j == "beneficiaryList") {
                                  if ($('.' + i + '_' + j + '_' + k + '_' + m).length > 0) {
                                    $('.' + i + '_' + j + '_' + k + '_' + m).addClass('red');
                                    none_ststus = true;
                                    // // console.log($('.' + i + '_' + j + '_' + k + '_' + m), 'red', i,j,k,m);
                                  }
                                } else {
                                  // twoStatus[j] = true;
                                  $('.' + i + '_' + j + '_' + k + '_' + m).length < 1 ? '' : twoStatus[j] = true;
                                  // // console.log('.' + i + '_' + j + '_' + k + '_' + m+'true');
                                }
                              }
                            } else {
                              // console.log("四级有值的情况", i, j, k, m, data[i][j][k][m]);
                              if (_this.agreementData.paramName == "zhongbangData" || _this.agreementData.paramName == "zhenxingData") { // 兴业协议的判断
                                $('.' + i + '_' + j + '_' + k + '_' + m).removeClass('red');
                              } else { // 京东协议的判断
                                if (j == "beneficiaryList") {
                                  $('.' + i + '_' + j + '_' + k + '_' + m).removeClass('red');
                                }
                              }
                            }
                          }



                        }
                      }
                    }

                    if (twoStatus[j]) {
                      if ($('.' + i + '_' + j).length > 0) {
                        $('.' + i + '_' + j).addClass('red');
                        none_ststus = true;
                        // // console.log($('.' + i + '_' + j), 'red', i,j);
                      }
                    } else {
                      $('.' + i + '_' + j).removeClass('red');
                    }


                  }

                } else { // 二级有值的情况
                  // console.log("二级有值的情况", i, j, data[i][j]);
                  $('.' + i + '_' + j).removeClass('red');
                  // // console.log("2remove." + i + '_' + j)
                }
              }
            }
          } else { // 一级有值的情况
            $('.' + i).removeClass('red');
            // console.log("一级有值的情况", i, data[i]);
            // // console.log("1remove."+i)
          }

        }
      }

      _this.addLoading();
      if (this.agreementData[this.agreementData.paramName].creditDto.idtStartDate1 && this.agreementData[this.agreementData.paramName].creditDto.idtEndDate1 && this.agreementData[this.agreementData.paramName].creditDto.startDate1 && this.agreementData[this.agreementData.paramName].creditDto.endDate1) {
        this.agreementData[this.agreementData.paramName].creditDto.legalValidDates = this.agreementData[this.agreementData.paramName].creditDto.idtStartDate1.replace(/-/g, '') + '-' + this.agreementData[this.agreementData.paramName].creditDto.idtEndDate1.replace(/-/g, '');
        this.agreementData[this.agreementData.paramName].creditDto.bnfValidDates = this.agreementData[this.agreementData.paramName].creditDto.startDate1.replace(/-/g, '') + '-' + this.agreementData[this.agreementData.paramName].creditDto.endDate1.replace(/-/g, '');
      }
      this.agreementData[this.agreementData.paramName].creditDto.custName = this.agreementData[this.agreementData.paramName].creditDto.custName.replace(/(\s*)/g, '')
      let requestData = {};
      requestData.bankSubJsonObj = this.agreementData[this.agreementData.paramName];
      requestData.bankSubJsonObj.creditJsonObj = this.agreementData[this.agreementData.paramName].creditDto;
      // console.log(requestData, "requestData");

      _this.submitData(requestData, '/web/discount-acct/apply-credit/');
    },
    // 提交数据
    submitData (requestData, url) {
      if (_this.uploadNum > 0) {
        _this.removeLoading();
        this.$Message.error('请等待文件上传成功之后再提交');
        return false;
      }
      if (!url) {
        url = '/web/discount-acct/bank/';
      }
      // 提交
      this.sendOther({
        url: url + _this.agreementData[_this.agreementData.paramName].bankId,
        data: requestData,
        method: "put"
      }, (result) => {
        // // console.log("ack回调", result);
        localStorage.removeItem('signBank' + this.agreementData[this.agreementData.paramName].bankId);
        this.saveData = false;
        this.$Message.success(result.data.message);
        this.$router.push('/SilverTicketManage');

      }, (result) => {
        // // console.log("其他回调", result);
      })
    },
    // 设置金额不能为大写的字符
    noAmountWords (arrayList) {
      arrayList.forEach((str) => {
        let strList = str.split('.');
        listValue(_this.agreementData[_this.agreementData.paramName], 0, strList);
      })

      function listValue (param, i, strList) {
        if (param.hasOwnProperty(strList[i])) {
          if (strList.length == i + 1) {
            console.log(param[strList[i]])
            param[strList[i]] = (param[strList[i]] && param[strList[i]].match(/^\d*(\.?\d{0,2})/g)[0]) || '';
            return param[strList[i]];
          } else {
            return listValue(param[strList[i]], ++i, strList);
          }
        }
      }
    },
    // 根据国标行业分类code获取行业名称
    findNameByIndustryType: function (list, code) {
      if (!code) return '';
      for (var i in list) {
        if (list[i].code == code) {
          return list[i].name;
        } else {
          if (list[i].subList != null) {
            var res = this.findNameByIndustryType(list[i].subList, code)
            if (res) { return res }
          }
        }
      }
      return '';
    },
    // 根据地区code获取地区名称
    findNameByAreaCode: function (list, code) {
      if (!code) return '';
      for (var i in list) {
        if (list[i].code == code) {
          return list[i].name;
        } else {
          if (list[i].subList != null) {
            var res = this.findNameByAreaCode(list[i].subList, code);
            if (res) { return res }
          }
        }
      }
    },
    initElement: async function () {

      // 初始化上传文件按钮
      $(".agreement_body").off("click", '.upload_img').on('click', '.upload_img', function () {
        $(this).parent().find('input').click();
        return false;
      });
      $(document).off("click", '.reupload_img').on("click", '.reupload_img', function () {
        $(this).parent().parent().siblings('.input_upload_img').click();
        return false;
      });

      $(document).off("click", '.reupload_file').on("click", '.reupload_file', function () {
        $(this).parent().parent().siblings('.input_upload_other_file').click();
        return false;
      });

      // 【贴现账户】增加/删除
      $(".agreement_body").on('click', '.add_acct', function () {
        _this.agreementData[_this.agreementData.paramName].creditDto.acctInfoList.push({
          discntAcctName: '', // 贴现账户名称
          discntAcctNo: '', // 贴现账号
          discntAcctOpenBankName: '', // 贴现账户开户行名称
          discntAcctOpenBankNo: '', // 贴现账户开户行号
        });
      });
      $(".agreement_body").on('click', '.del_acct', function () {
        let index = $(this).attr("data-index");
        if (_this.agreementData[_this.agreementData.paramName].creditDto.acctInfoList.length > 1) {
          // 数组删除
          _this.agreementData[_this.agreementData.paramName].creditDto.acctInfoList.splice(index, 1);
        } else {
          _this.agreementData[_this.agreementData.paramName].creditDto.acctInfoList.splice(index, 1);
          $('.add_acct').click();
        }
      });
      _this.initEleAdd();

    },
    initEleAdd: function () {
      // 输入框为日期格式 --- 横线格式分割 ---(默认)
      $('.agreement_body .maturityDate:not(".slashDate")').fdatepicker({ format: 'yyyy-mm-dd' });
      $('.agreement_body .maturityDateLong:not(".slashDate")').fdatepicker({ format: 'yyyy-mm-dd' }, "长期");

      // 输入框为日期格式 --- 斜线分割
      $('.agreement_body .maturityDate.slashDate').fdatepicker({ format: 'yyyy/mm/dd' });
      $('.agreement_body .maturityDateLong.slashDate').fdatepicker({ format: 'yyyy/mm/dd' }, "长期");

      // 多级联动初始化数据
      $('.agreement_body .maturityDate').fdatepicker({ format: 'yyyy-mm-dd' });
      $('.agreement_body .maturityDateLong').fdatepicker({ format: 'yyyy-mm-dd' }, "长期");

      // 非数组中的处理
      $('.agreement_body').off("change", ".dateParentNotArray").on("change", ".dateParentNotArray", function () {
        let array = String($(this).attr("data-link")).split('.');
        // // console.log(array);

        let cuDate = _this.getDateString($(this).val());

        if (array.length == 2) {
          _this.agreementData[array[0]][array[1]] = cuDate;
        } else if (array.length == 3) {
          _this.agreementData[array[0]][array[1]][array[2]] = cuDate;
        }

      });

      // 数组中的处理
      $('.agreement_body').off("change", ".dateParentArray").on("change", ".dateParentArray", function () {
        let array = String($(this).attr("data-link")).split('.');
        let index = $(this).attr("data-index");
        // console.log("change dateParentArray", array, index, array[0])
        // // console.log(array);

        let cuDate = _this.getDateString($(this).val());

        if (array.length == 2) {
          _this.agreementData[array[0]][index][array[1]] = cuDate;
        } else if (array.length == 3) {
          _this.agreementData[array[0]][array[1]][index][array[2]] = cuDate;
        } else if (array.length == 4) {
          _this.agreementData[array[0]][array[1]][array[2]][index][array[3]] = cuDate;
        } else if (array.length == 5) {
          _this.agreementData[array[0]][array[1]][array[2]][array[3]][array[4]] = cuDate;
        }

        // console.log(_this.agreementData);

        // data-link="fumingData.corp.stockholderList.certExpiryDate" :data-index="index"
        // var that = this;
        // var name = $(this).attr("data-link");
        // $.observable($.view(that).data).setProperty(name, $(that).val());
        // // console.log(name,$(that).val());
      });
      // 多级联动初始化数据
      $('.agreement_body .maturityCity').maturityTandem(_this.agreementData.baseDate.areaCode);
      $('.agreement_body .maturityIndustry').maturityTandem(_this.agreementData.cuIndustry); // 如果是振兴则使用industryTypeZhenx，众邦则使用industryTypeZbank，如果是京东则使用industryType
      // 多级联动事件， 数组中的处理
      $('.agreement_body').off("change", ".maturityTandemArray").on("change", ".maturityTandemArray", function () {
        // console.log("change");
        let array = String($(this).attr("data-link")).split('.');
        let index = $(this).attr("data-index");
        // // console.log(array);
        if (array.length == 2) {
          _this.agreementData[array[0]][index][array[1]] = $(this).val();
          _this.agreementData[array[0]][index][array[1].slice(0, -4)] = $(this).attr("code");
        } else if (array.length == 3) {
          _this.agreementData[array[0]][array[1]][index][array[2]] = $(this).val();
          _this.agreementData[array[0]][array[1]][index][array[2].slice(0, -4)] = $(this).attr("code");
        } else if (array.length == 4) {
          _this.agreementData[array[0]][array[1]][array[2]][index][array[3]] = $(this).val();
          _this.agreementData[array[0]][array[1]][array[2]][index][array[3].slice(0, -4)] = $(this).attr("code");
        }
        // console.log($(this), $(this).attr("code"), $(this).val());
      });
      // 非数组中的处理
      $('.agreement_body').off("change", ".maturityTandem:not('.maturityTandemArray')").on("change", ".maturityTandem:not('.maturityTandemArray')", function () {
        // console.log("change");
        let array = String($(this).attr("data-link")).split('.');
        // // console.log(array);
        if (array.length == 2) {
          _this.agreementData[array[0]][array[1]] = $(this).val();
          _this.agreementData[array[0]][array[1].slice(0, -4)] = $(this).attr("code");
        } else if (array.length == 3) {
          _this.agreementData[array[0]][array[1]][array[2]] = $(this).val();
          _this.agreementData[array[0]][array[1]][array[2].slice(0, -4)] = $(this).attr("code");
        }
      });
    },
    getDateString (val) {
      let cuDate = '';
      if (_this.agreementData.type == "WHLH") { // 蓝海自渠道协议特别
        cuDate = val == '长期' ? '2999/12/31' : val;
      } else { // 京东协议
        cuDate = val;
      }
      return cuDate;
    },

    // 获取图片
    getUrlOrBase64 (url) {
      // 判断url是base64格式还是图片的路径地址
      if (_this.isBase64(url)) {
        // base64格式
        return url;
      } else {
        if (url.indexOf('http') > -1) {
          return url;
        }
        return this.getImgUrl(url);
      }
    },
    // 处理图片
    getImg: function (e, param) {
      var that = this;
      this.imgToBase64(e, function (base, fileTarget) {
        // console.log(base, "base");
        that.ticketBase64 = base;
        let array = param.split('.');
        // console.log('array', array);
        // 进行OCR识别
        if (array.length == 6 && array[4] == 0 && array[3] == 'licenceFileList') {
          /*营业执照不进行OCR识别
          that.ocrRecognition('businessLicense', that.ticketBase64, function (data) {
            // console.log(data, "data");
            if(data.data.code == "ACK") {
              that.agreementData[array[1]].creditDto.custNm = data.data.data.name; // 识别的公司名称
              that.agreementData[array[1]].creditDto.certNo = data.data.data.reg_num; // 识别的统一社会信用代码
            }
            that.$Message.success(data.data.message);
          })*/
        } else if (array.length == 6 && array[4] == 3 && array[3] == 'licenceFileList') {
          // 法人身份证正面
          // console.log('ocr')
          that.ocrRecognition('idCardFace', that.ticketBase64, function (data) {
            // console.log(data, "data");
            if (data.data.code == "ACK") {
              that.agreementData[array[1]].creditDto.managerList[0].legalPerson = data.data.data.name; // 识别的姓名
              that.agreementData[array[1]].creditDto.managerList[0].idCard = data.data.data.num; // 识别的身份证号码
            }
            that.$Message.success(data.data.message);
          })
        } else if (array.length == 6 && array[4] == 5 && array[3] == 'licenceFileList') {
          // 签约人身份证正面
          that.ocrRecognition('idCardFace', that.ticketBase64, function (data) {
            // console.log(data, "data");
            if (data.data.code == "ACK") {
              that.agreementData[array[1]].creditDto.contactList[0].contactNm = data.data.data.name; // 识别的姓名
              that.agreementData[array[1]].creditDto.contactList[0].contactId = data.data.data.num; // 识别的身份证号码
            }
            that.$Message.success(data.data.message);
          })
        } else if (array.length == 6 && array[4] == 7 && array[3] == 'licenceFileList') {
          // 受益人身份证正面
          that.ocrRecognition('idCardFace', that.ticketBase64, function (data) {
            // console.log(data, "data");
            if (data.data.code == "ACK") {
              that.agreementData[array[1]].creditDto.beneficiaryList[0].benefitNm = data.data.data.name; // 识别的姓名
              that.agreementData[array[1]].creditDto.beneficiaryList[0].cardNo = data.data.data.num; // 识别的身份证号码
            }
            that.$Message.success(data.data.message);
          })
        } else if (array.length == 6 && array[4] == 9 && array[3] == 'licenceFileList') {
          // 实际控制人证照
          that.ocrRecognition('idCardFace', that.ticketBase64, function (data) {
            // console.log(data, "data");
            if (data.data.code == "ACK") {
              that.agreementData[array[1]].creditDto.ownerList[0].controller = data.data.data.name; // 识别的姓名
              that.agreementData[array[1]].creditDto.ownerList[0].cardNo = data.data.data.num; // 识别的身份证号码
            }
            that.$Message.success(data.data.message);
          })
        }


        if (array.length == 6 && array[4] == 0 && array[3] == 'fileDataList') {
          /*营业执照不进行OCR识别
          that.ocrRecognition('businessLicense', that.ticketBase64, function (data) {
            // console.log(data, "data");
            if(data.data.code == "ACK") {
              that.agreementData[array[1]].creditDto.corpName = data.data.data.name; // 识别的公司名称
              that.agreementData[array[1]].creditDto.identNo = data.data.data.reg_num; // 识别的统一社会信用代码
            }
            that.$Message.success(data.data.message);
          })*/
        } else if (array.length == 6 && array[4] == 5 && array[3] == 'fileDataList') {
          // 法人身份证正面
          that.ocrRecognition('idCardFace', that.ticketBase64, function (data) {
            // console.log(data, "data");
            if (data.data.code == "ACK") {
              that.agreementData[array[1]].creditDto.lpName = data.data.data.name; // 识别的姓名
              that.agreementData[array[1]].creditDto.lglPrsnRprsIdNo = data.data.data.num; // 识别的身份证号码
            }
            that.$Message.success(data.data.message);
          })
        } else if (array.length == 6 && array[4] == 7 && array[3] == 'fileDataList') {
          // 受托人身份证正面
          that.ocrRecognition('idCardFace', that.ticketBase64, function (data) {
            // console.log(data, "data");
            if (data.data.code == "ACK") {
              that.agreementData[array[1]].creditDto.opName = data.data.data.name; // 识别的姓名
              that.agreementData[array[1]].creditDto.opCertNo = data.data.data.num; // 识别的身份证号码
            }
            that.$Message.success(data.data.message);
          })
        }

        let paramList = param.split('.');
        _this.setArrayVal(`${param}Loading`.split('.'), true);
        // 图片上传
        _this.uploadNum++;
        if (e.target.dataset.uploadtype === 'oss') {
          // oss上传
          _this.ossUpload(fileTarget, async (data) => {
            console.log('====== oss =========', data);
            // _this.removeLoading();
            const clearname = e.target.dataset.clearname
            _this.setArrayVal(paramList, data.url);
            _this.setArrayVal(clearname.split('.'), '');
            await _this.uploadBaixin(paramList, data.url)
            console.log('======================================jeig')
            _this.setArrayVal(`${param}Loading`.split('.'), false);
            _this.uploadNum--;
          })
        } else {
          $.when(_this.uploadImg(param, base))
            .done(function () {
              console.log('隐藏', param, _this.agreementData);
              _this.setArrayVal(`${param}Loading`.split('.'), false);
              _this.uploadNum--;
            })
            .fail(function () {
              this.$Message.error('上传签约资料图片失败');
              return false;
            })
        }
        // 不进行图片上传
        // _this.setArrayVal(paramList, base);

      });
    },

    // 图片上传
    uploadImg (param, base) {
      // 判断是否是base64格式，是base64格式则进行文件上传
      let dtd = $.Deferred(); //在函数内部，新建一个Deferred对象
      if (_this.isBase64(base)) {
        // 上传文件之后，正在加载中的样式不消失
        _this.uploadFile(base, function (data) {
          let paramList = param.split('.');
          _this.setArrayVal(paramList, data[0]);

          /*if(paramList.length == 4) {
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]] = data[0];
            _this[paramList[0]][paramList[1]][paramList[2]].hasOwnProperty('fileId') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].fileId = '' : '';
            _this[paramList[0]][paramList[1]][paramList[2]].hasOwnProperty('flPth') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].flPth = '' : '';
          }else if(paramList.length == 5) {
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]] = data[0];
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]].hasOwnProperty('fileId') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].fileId = '' : '';
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]].hasOwnProperty('flPth') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].flPth = '' : '';
          }else if(paramList.length == 6) {
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]][paramList[5]] = data[0];
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].hasOwnProperty('fileId') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].fileId = '' : '';
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].hasOwnProperty('flPth') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].flPth = '' : '';
          }*/
          // console.log(_this.agreementData, data[0], param);
          dtd.resolve();
        }, true)
      } else {
        dtd.resolve();
      }
      return dtd.promise();
    },

    // 如果是振兴银行则调协议接口
    getAgreement (pic) {
      let dtd = $.Deferred(); //在函数内部，新建一个Deferred对象
      let paramList = pic.split('.');
      if (_this.agreementData.paramName == 'zhenxingData') {
        let ajaxData = {};
        ajaxData.bankId = _this.agreementData[_this.agreementData.paramName].bankId;
        ajaxData.protocolParam = {};
        ajaxData.protocolParam.KeyCorpName = _this.agreementData[_this.agreementData.paramName].creditDto.custNm;
        ajaxData.protocolParam.KeyCreditAddr = _this.agreementData[_this.agreementData.paramName].creditDto.belongProvName;

        this.sendMessage({
          method: 'post',
          url: '/web/discount-acct/bank/credit/protocol',
          data: ajaxData,
          tip: false,
        }, (result) => {
          // 关闭等待图
          // 得到协议
          console.log(result.data.data, "ACKData.data");

          _this.setArrayVal(paramList, result.data.data);

          /*if(paramList.length == 4) {
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]] = result.data.data;
          }else if(paramList.length == 5) {
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]] = result.data.data;
          }else if(paramList.length == 6) {
            _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]][paramList[5]] = result.data.data;
          }*/
          dtd.resolve();
        })

      }

      return dtd.promise();

    },

    // 查看图片
    searchImg (val) {
      this.$emit('show-img-data', val)
    },

    // 处理其他文件
    getOtherFile: function (e, param) {
      var that = this;
      // console.log(e.target.dataset.filetype, "filetype");
      if (!e.target.dataset.filetype) {
        if ($(e.target)[0].value != '' && !(/.(jpg|JPG)$/.test($(e.target)[0].value) || /.(png|PNG)$/.test($(e.target)[0].value) || /.(pdf|PDF)$/.test($(e.target)[0].value))) {
          $(e.target)[0].value = '';
          this.$Message.error("文件类型只能是jpg、png、pdf文件");
          return false;
        }
      }

      this.getScopeFile(e, function (base) {
        // console.log(base, "base");
        // _this.addLoading();
        _this.uploadNum++;
        let paramList = param.split('.');
        _this.setArrayVal(`${param}Loading`.split('.'), true);
        let formData = new FormData();
        formData.append("file", base);
        that.uploadFileOther(formData, function (data) {
          _this.removeLoading();
          // console.log("data", data);
          _this.setArrayVal(paramList, data);
          _this.setArrayVal(`${param}Loading`.split('.'), false);
          _this.uploadNum--;
        })
      });
    },

    // 设置值
    setArrayVal (paramList, val) {

      if (paramList.length == 4) {
        // _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]] = val;
        _this.$set(_this[paramList[0]][paramList[1]][paramList[2]], paramList[3], val);
        _this[paramList[0]][paramList[1]][paramList[2]].hasOwnProperty('fileId') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].fileId = '' : '';
        _this[paramList[0]][paramList[1]][paramList[2]].hasOwnProperty('flPth') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].flPth = '' : '';
      } else if (paramList.length == 5) {
        // _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]] = val;
        _this.$set(_this[paramList[0]][paramList[1]][paramList[2]][paramList[3]], paramList[4], val);
        _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]].hasOwnProperty('fileId') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].fileId = '' : '';
        _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]].hasOwnProperty('flPth') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].flPth = '' : '';
      } else if (paramList.length == 6) {
        // _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]][paramList[5]] = val;
        _this.$set(_this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]], paramList[5], val);
        _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].hasOwnProperty('fileId') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].fileId = '' : '';
        _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].hasOwnProperty('flPth') ? _this[paramList[0]][paramList[1]][paramList[2]][paramList[3]][paramList[4]].flPth = '' : '';
      }

    },

    // 下载文件
    downFile: function (url) {
      window.open(url);
    },

    // 查看其他文件
    getFileUrlByType (url, type) {
      // console.log(url, type)
      let cuUrl = '';
      if (type) { // type为真限制了文件类型
        switch (type) {
          case 'xlsx':
            cuUrl = '/static/img/img_tip/xmls.png'
            break;
          case 'doc':
            cuUrl = '/static/img/img_tip/doc.png'
            break;
          case 'pdf':
            cuUrl = '/static/img/img_tip/pdf.png'
            break;
        }
      } else {
        if (/.(jpg|JPG)$/.test(url)) {
          cuUrl = '/static/img/img_tip/word_jpg@2x.png';
        } else if (/.(png|PNG)$/.test(url)) {
          cuUrl = '/static/img/img_tip/word_png@2x.png';
        } else if (/.(pdf|PDF)$/.test(url)) {
          cuUrl = '/static/img/img_tip/word_pdf@2x.png';
        } else if (/.(doc|DOC|docx|DOCX)$/.test(url)) {
          cuUrl = '/static/img/img_tip/doc.png';
        } else if (/.(xlsm|XLSM|xlsx|XLSX)$/.test(url)) {
          cuUrl = '/static/img/img_tip/xmls.png';
        }
        // console.log(url, 'urllllll');
      }
      return cuUrl;
    },

    searchCompanyInfoEvent () {
      console.log(_this.agreementData[_this.agreementData.paramName])
      if (!(_this.agreementData[_this.agreementData.paramName].creditDto.certId && _this.agreementData[_this.agreementData.paramName].creditDto.mobile && _this.agreementData[_this.agreementData.paramName].creditDto.stateOwnedFlag)) {
        this.$Message.error('请先完善统一社会信用代码、联系人手机号码和国企标志');
        return false;
      }
      this.addLoading();
      this.sendGet({
        url: '/web/fm-discount/business',
        data: {
          certId: _this.agreementData[_this.agreementData.paramName].creditDto.certId,
          mobile: _this.agreementData[_this.agreementData.paramName].creditDto.mobile,
          stateOwnedFlag: _this.agreementData[_this.agreementData.paramName].creditDto.stateOwnedFlag,
        }
      }, (result) => {
        console.log('result', result.data.data)
        _this.agreementData[_this.agreementData.paramName].creditDto = result.data.data;
      }, (result) => {
        // // console.log("其他回调", result);
      })
      console.log('111111111')
    },

    // 获取鉴定金额
    getCheckMoneyEvent () {
      console.log('====== 获取鉴定金额 ====', this.agreementData)
      var requestData = {
        userId: this.agreementData.baseDate.corp.userId,
        corpName: this.agreementData[this.agreementData.paramName].creditDto.enterpriseName, // 企业名称
        blicNo: this.agreementData[this.agreementData.paramName].creditDto.certId, // 营业执照号
        lepName: '', // 法人姓名
        lepNo: '', // 法人身份证号
        acctNo: this.agreementData[this.agreementData.paramName].creditDto.corpAcctNo, // 企业对公账户账号
        bankId: this.agreementData[this.agreementData.paramName].creditDto.bankId // 中金认证支持银行ID
      }
      if (!requestData.corpName) {
        this.$Message.error('请输入企业名称')
        return false;
      } else if (!requestData.blicNo) {
        this.$Message.error('请输入社会统一信用代码')
        return false;
      } else if (!requestData.acctNo) {
        this.$Message.error('请输入网银账号')
        return false;
      } else if (!requestData.bankId) {
        this.$Message.error('请选择开户行')
        return false;
      }
      const legaArray = this.agreementData[this.agreementData.paramName].creditDto.manageArray.filter(item => item.relationShip === '0100')
      if (legaArray.length > 0) {
        requestData.lepName = legaArray[0].customerName;
        requestData.lepNo = legaArray[0].certId;
      }
      if (!requestData.lepName || !requestData.lepNo) {
        this.$Message.error('请在高管信息中完善一条职务为法人代表的信息')
        return false;
      }
      this.addLoading();
      this.sendMessage({
        method: 'post',
        url: '/web/cpcn-kyc/identify',
        data: requestData,
        successCallback: (result) => {
          this.$Message.success(result.data.message)

          this.getCheckAmountDetail();

        }
      })
    },

    // ================= 处理OSS文件上传 =========================
    // 处理其他文件
    uploadOSSFile: function (e, param) {
      var that = this;
      console.log(e.target, "filetype", Boolean(e.target.dataset.filetype));
      if (e.target.files[0].size < 600 && /.(PNG|JPG|JPEG)/.test($(e.target)[0].value.toUpperCase())) {
        this.$Message.error("上传文件需要小于600KB");
        return false
      }
      if (!e.target.dataset.filetype) {
        if ($(e.target)[0].value != '' && !(/.(jpg|JPG)$/.test($(e.target)[0].value) || /.(png|PNG)$/.test($(e.target)[0].value) || /.(pdf|PDF)$/.test($(e.target)[0].value))) {
          $(e.target)[0].value = '';
          this.$Message.error("文件类型只能是jpg、png、pdf文件");
          return false;
        }
      } else {
        // filetype是组合的情况，doc,pdf,png,pdf
        let regexValue = false; // 文件符合要求
        if (/.(jpg|JPG)$/.test($(e.target)[0].value)) {
          if (e.target.dataset.filetype.indexOf('jpg') < 0) {
            regexValue = true;
          }
        } else if (/.(png|PNG)$/.test($(e.target)[0].value)) {
          if (e.target.dataset.filetype.indexOf('png') < 0) {
            regexValue = true;
          }
        } else if ((/.(pdf|PDF)$/).test($(e.target)[0].value)) {
          if (e.target.dataset.filetype.indexOf('pdf') < 0) {
            regexValue = true;
          }
        } else if ((/.(doc|DOC|docx|DOCX)$/).test($(e.target)[0].value)) {
          if (e.target.dataset.filetype.indexOf('doc') < 0) {
            regexValue = true;
          }
        } else if ((/.(xlsm|XLSM|xlsx|XLSX)$/).test($(e.target)[0].value)) {
          if (e.target.dataset.filetype.indexOf('xlsx') < 0) {
            regexValue = true;
          }
        } else {
          regexValue = true;
        }

        if (regexValue) {
          $(e.target)[0].value = '';
          this.$Message.error('文件类型必须是' + e.target.dataset.filetype + '中的一种');
          return false;
        }
      }
      this.getScopeFile(e, function (base) {
        // console.log(base, "base");
        // _this.addLoading();
        _this.uploadNum++;
        let paramList = param.split('.');
        _this.setArrayVal(`${param}Loading`.split('.'), true);

        _this.ossUpload(base, async (data) => {
          console.log('====== oss =========', data);
          _this.removeLoading();
          // console.log("data", data);
          const clearname = e.target.dataset.clearname
          _this.setArrayVal(paramList, data.url);
          _this.setArrayVal(clearname.split('.'), '');

          await _this.uploadBaixin(paramList, data.url)
          console.log('======================================jeig')
          _this.setArrayVal(`${param}Loading`.split('.'), false);
          _this.uploadNum--;
        })
      });
    },
    async uploadBaixin (array, url) {
      // 判断上传的是什么文件
      const req = {
        blicNo: this.agreementData[this.agreementData.paramName].creditDto.certNo,
        ossUrl: url
      }
      switch (array[array.length - 1]) {
        case 'businessFaceIdOss':
          req.billType = '01'
          break;
        case 'identityFaceIdOss':
          req.billType = '02'
          break;
        case 'identityBackIdOss':
          req.billType = '03'
          break;
        case 'preyearProfitStatementIdOss':
          req.billType = '04'
          break;
        case 'preyearBalanceSheetIdOss':
          req.billType = '05'
          break;
        case 'authorizationAgreementOss':
          req.billType = '09'
          break;
        case 'bxBankLetterOfAuthorizationOss':
          req.billType = '11'
          break;
        case 'bnfIdNumDueOss':
          req.billType = '14'
          break;
        case 'bnfIdNumBackOss':
          req.billType = '15'
          break;
      }

      console.log('req', req)
      // 百信贴现-文件上传

      let ACKData = (await uploadBaixinFile(req, () => {
        _this.setArrayVal(array, '');
        _this.uploadNum--;
      })).data;
      console.log('ACKData', ACKData)
      switch (req.billType) {
        case '01': // 营业执照
          array[array.length - 1] = 'businessFaceId'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          array[array.length - 1] = 'businessAddr'
          _this.setArrayVal(array, ACKData.data.businessAddr);
          break;
        case '02': // 法定代表人身份证（正）
          array[array.length - 1] = 'identityFaceId'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          array[array.length - 1] = 'legalPersonName'
          _this.setArrayVal(array, ACKData.data.cname);
          array[array.length - 1] = 'legalIdNum'
          _this.setArrayVal(array, ACKData.data.idNum);
          array[array.length - 1] = 'legalAddr'
          _this.setArrayVal(array, ACKData.data.addr);
          break;
        case '03': // 法定代表人身份证（反）
          array[array.length - 1] = 'identityBackId'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          array[array.length - 1] = 'legalValidDates'
          _this.setArrayVal(array, ACKData.data.validDates);
          array[array.length - 1] = 'idtStartDate1'
          _this.setArrayVal(array, ACKData.data.validDates.split('-')[0].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3'));
          array[array.length - 1] = 'idtEndDate1'
          _this.setArrayVal(array, ACKData.data.validDates.split('-')[1].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3'));
          break;
        case '04':
          array[array.length - 1] = 'preyearProfitStatementId'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          break;
        case '05':
          array[array.length - 1] = 'preyearBalanceSheetId'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          break;
        case '09':
          array[array.length - 1] = 'authorizationAgreement'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          break;
        case '11':
          array[array.length - 1] = 'bxBankLetterOfAuthorization'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          break;
        case '14':
          array[array.length - 1] = 'bnfIdNumDue'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          array[array.length - 1] = 'bnfName'
          _this.setArrayVal(array, ACKData.data.cname);
          array[array.length - 1] = 'bnfCertNo'
          _this.setArrayVal(array, ACKData.data.idNum);
          array[array.length - 1] = 'bnfAddr'
          _this.setArrayVal(array, ACKData.data.addr);
          break;
        case '15':
          array[array.length - 1] = 'bnfIdNumBack'
          _this.setArrayVal(array, ACKData.data.fileUrl);
          array[array.length - 1] = 'bnfValidDates'
          _this.setArrayVal(array, ACKData.data.validDates);
          array[array.length - 1] = 'startDate1'
          _this.setArrayVal(array, ACKData.data.validDates.split('-')[0].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3'));
          array[array.length - 1] = 'endDate1'
          _this.setArrayVal(array, ACKData.data.validDates.split('-')[1].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3'));
          break;
      }
    },
    // 处理文件展示和上传
    fileHandle (ossUrl) {
      if (/.(pdf|PDF)$/.test(ossUrl)) {
        return 'download'
      } else if (/.(doc|DOC|docx|DOCX)$/.test(ossUrl)) {
        return 'download'
      } else if (/.(jpg|JPG|jpeg|JPEG)$/.test(ossUrl)) {
        return 'show'
      } else if (/.(png|PNG)$/.test(ossUrl)) {
        return 'show'
      } else {
        return 'download'
      }
    },
    fileHandleShow (url) {
      if (this.fileHandle(url) == 'show') {
        console.log('展示')
        this.searchImg(url);
      } else {
        this.downFile(url);
      }
    },

  },
  filters: {
    formatterMobile (value) {
      if (value && value.length == 11) {
        let mobile = value.slice(0, 3) + '-' + value.slice(3, 7) + '-' + value.slice(7);
        return mobile
      }
      return '';
    }
  },
  mounted: function () {
    // 初始化复制
    // this.initBtnCopy()

    console.log($(".relevanceCompany"), 'mounted');

    this.$nextTick(function () {
      // 此处填第一次渲染完成后执行的代码
      this.initElement();
      console.log($(".relevanceCompany"), 'nextTick');
    })
  },
  updated: function () {
    this.$nextTick(function () {
      // 此处填每次渲染完后执行的代码
      this.initEleAdd();
      // 多级联动事件， 数组中的处理
      $('.agreement_body .maturityTandemArray').each(function () {
        let array = String($(this).attr("data-link")).split('.');
        let index = $(this).attr("data-index");
        // console.log(array);
        if (array.length == 2) {
          if (_this.agreementData[array[0]][index][array[1].slice(0, -4)]) {
            if ($(this).hasClass("maturityIndustry")) {
              _this.agreementData[array[0]][index][array[1]] = _this.findNameByIndustryType(_this.agreementData.cuIndustry, _this.agreementData[array[0]][index][array[1].slice(0, -4)]);
              // // console.log(_this.findNameByIndustryType(_this.agreementData.baseDate.industryType, _this.agreementData[array[0]][index][array[1].slice(0,-4)]));
            } else {
              _this.agreementData[array[0]][index][array[1]] = _this.findNameByAreaCode(_this.agreementData.baseDate.areaCode, _this.agreementData[array[0]][index][array[1].slice(0, -4)]);
              // // console.log(_this.findNameByIndustryType(_this.findNameByAreaCode(_this.agreementData.baseDate.areaCode, _this.agreementData[array[0]][index][array[1].slice(0,-4)])));
            }
          }
          // // console.log(_this.agreementData[array[0]][index][array[1].slice(0,-4)], _this.agreementData[array[0]][index][array[1]])
        } else if (array.length == 3) {
          // console.log(_this.agreementData[array[0]][array[1]][index][array[2].slice(0, -4)], "test");
          if (_this.agreementData[array[0]][array[1]][index][array[2].slice(0, -4)]) {
            let cuData = "";
            if ($(this).hasClass("maturityIndustry")) {
              cuData = _this.findNameByIndustryType(_this.agreementData.cuIndustry, _this.agreementData[array[0]][array[1]][index][array[2].slice(0, -4)]);
            } else {
              cuData = _this.findNameByAreaCode(_this.agreementData.baseDate.areaCode, _this.agreementData[array[0]][array[1]][index][array[2].slice(0, -4)]);
            }
            _this.$set(_this.agreementData[array[0]][array[1]][index], [array[2]], cuData);
          }
          // // console.log(_this.agreementData[array[0]][array[1]][index][array[2].slice(0,-4)], _this.agreementData[array[0]][array[1]][index][array[2]])
        } else if (array.length == 4) {
          if (_this.agreementData[array[0]][array[1]][array[2]][index][array[3].slice(0, -4)]) {
            let cuData = "";
            if ($(this).hasClass("maturityIndustry")) {
              cuData = _this.findNameByIndustryType(_this.agreementData.cuIndustry, _this.agreementData[array[0]][array[1]][array[2]][index][array[3].slice(0, -4)]);
            } else {
              cuData = _this.findNameByAreaCode(_this.agreementData.baseDate.areaCode, _this.agreementData[array[0]][array[1]][array[2]][index][array[3].slice(0, -4)]);
            }
            _this.$set(_this.agreementData[array[0]][array[1]][array[2]][index], [array[3]], cuData);
            // console.log("cuData", cuData, _this.agreementData[array[0]][array[1]][array[2]][index], [array[3]]);
          }
          // // console.log(_this.agreementData[array[0]][array[1]][array[2]][index][array[3].slice(0,-4)], _this.findNameByAreaCode(_this.agreementData[array[0]][array[1]][array[2]][index][array[3]]))
        }
      });
      // 非数组中的处理
      $(".agreement_body .maturityTandem:not('.maturityTandemArray')").each(function () {
        let array = String($(this).attr("data-link")).split('.');
        if (array.length == 2) {
          if (_this.agreementData[array[0]][array[1].slice(0, -4)]) {
            let cuData = "";
            if ($(this).hasClass("maturityIndustry")) {
              cuData = _this.findNameByIndustryType(_this.agreementData.cuIndustry, _this.agreementData[array[0]][array[1].slice(0, -4)]);
            } else {
              cuData = _this.findNameByAreaCode(_this.agreementData.baseDate.areaCode, _this.agreementData[array[0]][array[1].slice(0, -4)]);
            }
            _this.$set(_this.agreementData[array[0]], [array[1]], cuData);
          }
        } else if (array.length == 3) {
          if (_this.agreementData[array[0]][array[1]][array[2].slice(0, -4)]) {
            let cuData = "";
            if ($(this).hasClass("maturityIndustry")) {
              cuData = _this.findNameByIndustryType(_this.agreementData.cuIndustry, _this.agreementData[array[0]][array[1]][array[2].slice(0, -4)]);
            } else {
              // _this.agreementData[array[0]][array[1]][array[2]] = _this.findNameByAreaCode(_this.agreementData.baseDate.areaCode, _this.agreementData[array[0]][array[1]][array[2].slice(0,-4)]);
              cuData = _this.findNameByAreaCode(_this.agreementData.baseDate.areaCode, _this.agreementData[array[0]][array[1]][array[2].slice(0, -4)]);
            }
            _this.$set(_this.agreementData[array[0]][array[1]], [array[2]], cuData);
          }
          // // console.log(_this.agreementData[array[0]][array[1]][array[2].slice(0,-4)], _this.findNameByAreaCode(_this.agreementData[array[0]][array[1]][array[2]]))
        }
      })
    })
  },
  created () {
    _this = this;
    // 页面跳转
    if (this.$route.params.id) {
      // {type:val.bankChannelType, discountChannel: 'jd', id: val.id})
      this.agreementData.baixinData.bankId = this.$route.params.id;
      console.log(this.$route.params.subtype, 'this.$route.params.subtype')
      this.subtype = this.$route.params.subtype || '';
      this.initData(this.$route.params.id);
      // console.log(this.$route.params.type, this.$route.params.id, this.agreementData.paramName)
    } else {
      this.$router.push('/SilverTicketManage');
    }

    // 监听页面刷新、跳转
    window.addEventListener("beforeunload", hashChangeFire);
    window.onbeforeunload = hashChangeFire;
    window.onunload = hashChangeFire;
    function hashChangeFire () {
      _this.saveData ? sessionStorage.setItem('signBank' + _this.agreementData[_this.agreementData.paramName].bankId, JSON.stringify(_this.agreementData)) : '';        // 存储数据
    }
  },
  beforeDestroy () {
    if (this.agreementData.paramName) {
      this.saveData ? localStorage.setItem('signBank' + this.agreementData[this.agreementData.paramName].bankId, JSON.stringify(this.agreementData)) : '';        // 存储数据
    }
  }
}
</script>

<style>
@import '../../../static/css/foundation-datepicker.less';
@import '../../../static/css/main.less';
.ivu_wh100 .ivu-spin-main,
.ivu_wh100 .ivu-spin-text {
  width: 100%;
  height: 100%;
}
/* 公共样式 */
.beforeStar::before {
  content: '*';
  margin-right: 4px;
  color: #d0021b;
}
.l124 {
  line-height: 124px;
}

input::-webkit-input-placeholder {
  color: #ccc;
}

/* 图片上传样式 */
.bgcolor {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
}
.img_hover_style {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  display: flex;
}
.img_hover_style > div {
  display: none;
}
.img_hover_style:hover > div {
  display: block;
}

/* 多级联动 */
.level li:hover {
  background-color: #fdf8e9;
  color: #e9b722;
  cursor: pointer;
}
.level li.active {
  font-weight: 700;
  color: #e9b722;
  background-color: #fbf1d3;
}
.level li {
  padding-left: 5px;
}

.level::-webkit-scrollbar {
  display: none;
}

.level {
  position: absolute;
  left: 0px;
  top: 23px;
  height: 300px;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  z-index: 8;
}
.level1 {
  left: 0px;
  width: 144px;
  top: 23px;
}
.level2 {
  left: 50px;
  width: 144px;
  top: 23px;
}
.level3 {
  left: 100px;
  width: 144px;
  top: 23px;
}
.level4 {
  left: 150px;
  width: 144px;
  top: 23px;
}
.red {
  border-color: #d0021b !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 4px #d0021b;
}
.agreement .upload_img {
  background-image: none;
}
.img_style {
  background-size: contain !important;
}
.img_style_82 {
  background-size: 82px !important;
}
/*删除按钮*/
.icon.remove {
  width: 13px;
  height: 17px;
  background: url(~@/assets/img/account/icon_delete@2x.png) no-repeat center
    center;
  background-size: contain;
  vertical-align: -3px;
  display: inline-block;
}

.agreement .h23.ivu-select-single .ivu-select-selection {
  height: 23px;
  line-height: 23px;
  padding: 0;
  margin: 0;
}

.agreement .ivu-select .ivu-select-dropdown {
  width: 100%;
}

.agreement .h23 .ivu-select-input {
  height: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BankAgreementBaiXin.vue